import { API_WSP } from 'src/constants/conversations';
import { TStoreAreas } from 'src/interfaces/store';

export const LEGACY_CONVERSATION_MODE = 'legacy';
export const CHANNELS_CONVERSATION_MODE = 'channels';

export const CONVERSATION_CHANNEL_OPTIONS = ['whatsapp'];

export const CONVERSATION_CHANNEL_PROVIDER_OPTIONS = ['twilio', 'meta'];

export const createDefaultConversationChannel = () => ({
    channel: 'whatsapp',
    provider: 'meta',
    isActive: true,
    isDefault: false,
    sender: {
        phone: '',
    },
    credentials: {
        accountId: '',
        token: '',
        tokenExpiresIn: '',
    },
    capabilities: {
        inbound: true,
        outbound: true,
        media: true,
    },
});

export const hasLegacyConversationConfig = (area: TStoreAreas) =>
    Boolean(
        area?.whatsapp ||
            area?.fb ||
            area?.wspAccount ||
            area?.wspToken ||
            area?.tokenExpiresIn
    );

export const createConversationChannelFromLegacy = (area: TStoreAreas) => {
    const hasWhatsappLegacy = Boolean(
        area?.whatsapp ||
            area?.wspAccount ||
            area?.wspToken ||
            area?.tokenExpiresIn
    );

    return {
        channel: 'whatsapp',
        provider:
            area?.api === API_WSP || !hasWhatsappLegacy ? 'meta' : 'twilio',
        isActive: hasWhatsappLegacy ? Boolean(area?.isWspAvailable) : true,
        isDefault: false,
        sender: {
            phone: hasWhatsappLegacy ? area?.whatsapp || '' : '',
        },
        credentials: {
            accountId: hasWhatsappLegacy
                ? area?.wspAccount || ''
                : area?.fb || '',
            token: area?.wspToken || '',
            tokenExpiresIn: area?.tokenExpiresIn || '',
        },
        capabilities: {
            inbound: true,
            outbound: true,
            media: true,
        },
        metadata: {
            importedFrom: LEGACY_CONVERSATION_MODE,
        },
    };
};
